import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { verifyEmail } from '../services/authService';
import styles from '../styles/admin/loginStyles';

const EmailVerification = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('verifying'); // verifying, success, error
    const [message, setMessage] = useState('Verifying your email...');
    const navigate = useNavigate();
    const hasVerified = useRef(false); // Prevent double execution in React Strict Mode

    useEffect(() => {
        const token = searchParams.get('token');

        if (!token) {
            setStatus('error');
            setMessage('Invalid verification link. No token provided.');
            return;
        }

        // Prevent double execution in React Strict Mode
        if (hasVerified.current) {
            console.log('[EmailVerification] Verification already attempted, skipping...');
            return;
        }
        hasVerified.current = true;

        const verify = async () => {
            try {
                console.log('[EmailVerification] Starting verification with token:', token);
                const response = await verifyEmail(token);
                console.log('[EmailVerification] Verification response:', response);

                setStatus('success');
                setMessage(response.message || 'Email verified successfully!');

                // Redirect to login after 3 seconds
                setTimeout(() => {
                    navigate('/login');
                }, 3000);
            } catch (error) {
                console.error('[EmailVerification] Verification failed:', error);
                console.error('[EmailVerification] Error message:', error.message);
                console.error('[EmailVerification] Error stack:', error.stack);

                setStatus('error');
                setMessage(error.message || 'Email verification failed. The link may be expired or invalid.');
            }
        };

        verify();
    }, [searchParams, navigate]);

    return (
        <div style={styles.wrapper}>
            <div style={styles.form}>
                <h2 style={styles.heading}>Email Verification</h2>

                {status === 'verifying' && (
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p style={{ marginTop: '20px', color: '#666' }}>{message}</p>
                    </div>
                )}

                {status === 'success' && (
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        <div style={{ fontSize: '48px', color: '#28a745', marginBottom: '20px' }}>
                            ✓
                        </div>
                        <p style={{ color: '#28a745', fontSize: '18px', marginBottom: '10px' }}>
                            {message}
                        </p>
                        <p style={{ color: '#666' }}>
                            Redirecting to login page...
                        </p>
                    </div>
                )}

                {status === 'error' && (
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        <div style={{ fontSize: '48px', color: '#dc3545', marginBottom: '20px' }}>
                            ✗
                        </div>
                        <p style={{ ...styles.errorMessage, fontSize: '16px' }}>
                            {message}
                        </p>
                        <button
                            style={{ ...styles.submitBtn, marginTop: '20px' }}
                            onClick={() => navigate('/login')}
                        >
                            Go to Login
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default EmailVerification;
